module.exports = __webpack_public_path__ + "static/media/code.9fbf9fd1.png";